module.exports = __webpack_public_path__ + "media/theme/blog__border-4-f53e08c7.png";